import React from "react";
import { FormattedDate } from "react-intl";

function DateCell({ cell: { value } }) {
    return <FormattedDate value={value} options={{ format: "short" }} />;
}

export default DateCell;